import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import InCountry from "../../Components/InCountry/InCountry";
import s from "./HivKazakhstan.module.scss";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import {
  getDiseaseDetails,
  getImportantToKnowDetails,
  getImportantToKnowList,
  getKazakhstanDiseaseDetails,
  getKazakhstanTripPreparationDetails,
  getKazakhstanTripPreperaionList,
} from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

interface Props {
  navigation: {
    name: string;
    path: string;
  };
}

const HIVKazahkstan = () => {
  const dispatch: AppDispatch = useDispatch();
  const disease = useSelector(
    (state: RootState) => state.info.kazakhstanDiseaseDetails,
  );
  const params = useParams();
  const tripPreparationList = useSelector(
    (state: RootState) => state.info.kazakhstanTripPreperaionList,
  );
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const lang = useSelector((state: RootState) => state.info.lang);
  const langs: Record<string, string> = {
    ru: "button_ru",
    kg: "button_ky",
    tj: "button_tg",
    uz: "button_uz",
  };

  useEffect(() => {
    dispatch(getKazakhstanDiseaseDetails(Number(params.id)));
    dispatch(getKazakhstanTripPreperaionList());
  }, [params]);

  const getPath = (button: string, id: number) => {
    switch (button) {
      case "Как подготовиться к поездке, если вы уже знаете о своем ВИЧ — статусе":
        return `/kazakhstan/hiv/trip/${id}`;
      case "Как получать лечение?":
        return `/kazakhstan/hiv/treatment/${id}`;
      case "Где и как сдать анализы?":
        return `/kazakhstan/hiv/analysis/${id}`;
      default:
        return `/kazakhstan/hiv`;
    }
  };

  return (
    <div>
      <Seo
        title="Миграция в Казахстан с ВИЧ"
        description="Можно ли въезжать и работать в Казахстан при ВИЧ-инфекции? Лечение ВИЧ для иностранцев / мигрантов в Казахстане"
        url="https://www.vputi.org/kazakhstan/hiv/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство Казахстана / Для мигрантов, живущих с ВИЧ",
            path: "/kazakhstan",
          }}
        />
        <ContactButtons />
        <div className={s.inner}>
          <div className={s.text}>
            <div className={s.text_title}>{disease?.title_1}</div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_1 ?? "" }}
            ></div>

            <div className={s.body_2_wrapper}>
              <div
                className={s.body2}
                dangerouslySetInnerHTML={{ __html: disease?.body_2 ?? "" }}
              ></div>
            </div>
            <div className={s.text_title2}>{disease?.title_3}</div>
            <div
              className={s.body3}
              dangerouslySetInnerHTML={{ __html: disease?.body_3 ?? "" }}
            ></div>
            <div
              className={s.body}
              dangerouslySetInnerHTML={{ __html: disease?.body_4 ?? "" }}
            ></div>
          </div>
          <div className={s.buttons}>
            {Array.isArray(tripPreparationList) &&
              [...tripPreparationList]
                .reverse()

                .map((it) => {
                  const field = langs[lang] || "button_ru";
                  const buttonText = (it as any)[field] || it.button;

                  return (
                    <Link
                      to={getPath(it.button, it.id)}
                      key={it.id}
                      className={s.button}
                      onClick={() => getKazakhstanTripPreparationDetails(it.id)}
                    >
                      {buttonText}
                    </Link>
                  );
                })}
          </div>
          <div className={s.title}>
            {t("Где я могу пройти обследования на родине?")}
          </div>

          <CountriesBlueButtons />
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default HIVKazahkstan;
